import { render } from "./FormDraggableList.vue?vue&type=template&id=536e5746&scoped=true"
import script from "./FormDraggableList.vue?vue&type=script&lang=js"
export * from "./FormDraggableList.vue?vue&type=script&lang=js"

import "./FormDraggableList.vue?vue&type=style&index=0&id=536e5746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536e5746"]])

export default __exports__